/**
 * Social Proof Section JavaScript
 * Handles video playback with minimal carousel interference
 */

class SocialProofSection {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.section = document.getElementById(sectionId);
    this.playButtons = this.section?.querySelectorAll('.social-proof-card__play-button');
    
    this.init();
  }

  init() {
    if (!this.section || !this.playButtons.length) return;
    
    this.setupVideoHandlers();
  }

  setupVideoHandlers() {
    this.playButtons.forEach(button => {
      const videoContainer = button.closest('.social-proof-card__video-container');
      const video = videoContainer?.querySelector('video');
      
      if (!video) return;

      // Ensure video starts with controls hidden
      video.controls = false;
      
      // Video event handlers
      video.addEventListener('play', () => this.handleVideoPlay(button, video));
      video.addEventListener('pause', () => this.handleVideoPause(button, video));
      video.addEventListener('ended', () => this.handleVideoEnd(button, video));
      
      // Play button click handler - minimal interference
      button.addEventListener('click', (e) => this.handlePlayButtonClick(e, video));
    });
  }

  handleVideoPlay(button, video) {
    button.style.display = 'none';
    video.controls = true;
  }

  handleVideoPause(button, video) {
    button.style.display = 'flex';
    video.controls = false;
  }

  handleVideoEnd(button, video) {
    button.style.display = 'flex';
    video.controls = false;
    video.muted = true;
  }

  handlePlayButtonClick(e, video) {
    e.preventDefault();
    e.stopPropagation();
    
    // Preload video when play button is clicked
    if (video.preload === 'none') {
      video.preload = 'metadata';
    }
    
    video.muted = false;
    video.play().catch(error => {
      console.warn('Video play failed:', error);
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const socialProofSections = document.querySelectorAll('[id^="shopify-section-"]');
  
  socialProofSections.forEach(section => {
    if (section.classList.contains('shopify-section--social-proof')) {
      new SocialProofSection(section.id);
    }
  });
});
